import { Component } from "@angular/core";
import { IVTableColumn } from "@app/directives/_layout/v-table/_models/IVTableColumn";
import { IVTableRow } from "@app/directives/_layout/v-table/_models/IVTableRow";
import { VTableService } from "@app/directives/_layout/v-table/_services/v-table.service";
import { VerticalFilterItemCreationCallback } from "@app/directives/_resourceFilters/vertical-filter-list/vertical-filter-list.component";
import { SortDirection } from "@app/enum/SortDirection";
import { SortType } from "@app/enum/SortType";
import { ISim, SimStatus, SimType } from "@app/interfaces/ISim";
import { ISimMapping } from "@app/interfaces/ISimMapping";
import { SimService } from "@app/main/modules/foundation/_services/sim.service";
import { TranslationService } from "@app/services/translation.service";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import './sim-list.component.scss';

@UntilDestroy()
@Component({
    selector: 'sim-list',
    template: require('./sim-list.component.html')
})
export class SimListComponent {

    sims: ISim[];
    selectedSim: ISim;

    selectedSimCurrentMapping: ISimMapping;

    tableColumns: IVTableColumn<ISim>[];
    tableRows: IVTableRow[];

    loading: boolean;

    SimType = SimType;
    SimStatus = SimStatus;

    constructor(
        private readonly simService: SimService,
        private readonly translationService: TranslationService,
        private readonly vTableService: VTableService) { }

    ngOnInit(): void {
        this.createTables();
        this.getData();
    }

    onRowClicked(row: IVTableRow): void {
        this.selectedSim = row.data;
    }

    simTypeItemCreationCallback: VerticalFilterItemCreationCallback<ISim> = (sim) => {
        return {
            name: this.translationService.tEnum(SimType, "SimType", sim.Type),
            icon: "person",
            data: sim,
            predicate: (s: ISim) => s.Type === sim.Type
        };
    }

    simStatusItemCreationCallback: VerticalFilterItemCreationCallback<ISim> = (sim) => {
        return {
            name: this.translationService.tEnum(SimStatus, "SimStatus", sim.Status),
            icon: "person",
            data: sim,
            predicate: (s: ISim) => s.Status === sim.Status
        };
    }

    clearSelectedSim(): void {
        this.selectedSim = undefined;
        this.selectedSimCurrentMapping = undefined;
    }

    onSimMappingFound(mapping: ISimMapping): void {
        this.selectedSimCurrentMapping = mapping;
    }

    //--

    private createTables(): void {
        this.tableColumns = [
            {
                header: this.vTableService.createTableHeader({ tKey: "FoundationSims.ICCID", sorted: true, sortType: SortType.Number, sortDirection: SortDirection.Descending }),
                createCellFunction: sim => this.vTableService.createTableCell(sim.Iccid)
            },
            {
                header: this.vTableService.createTableHeader({ title: "Id" }),
                createCellFunction: sim => this.vTableService.createTableCell(sim.Id)
            },
            {
                header: this.vTableService.createTableHeader({ tKey: "FoundationSims.Imsi" }),
                createCellFunction: sim => this.vTableService.createTableCell(sim.Imsi)
            },
            {
                header: this.vTableService.createTableHeader({ tKey: "Common.Type" }),
                createCellFunction: sim => this.vTableService.createEnumCell(SimType, "SimType", sim.Type)
            },
            {
                header: this.vTableService.createTableHeader({ tKey: "Common.Status" }),
                createCellFunction: sim => this.vTableService.createEnumCell(SimStatus, "SimStatus", sim.Status)
            }
        ];

    }

    private createTableRows(): void {
        this.tableRows = this.vTableService.createTableRows(this.sims, this.tableColumns);
    }

    private getData(): void {
        this.loading = true;

        this.simService.getSims().pipe(
            untilDestroyed(this)
        ).subscribe({
            next: sims => {
                this.sims = sims;
                this.createTableRows();
            }                    ,
            complete: () => this.loading = false,
            error: () => this.loading = false
        })
    }

    
}
